import { useMutation } from "@tanstack/react-query";
import api from "../../services";

import useToast from "../useToast";

import { IJobPostList } from "../../interfaces/job_posts";

interface ICopyJobPostPayload {
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>;
    successCallback: (data: IJobPostList) => void;
    payload: {
        id: number;
    }
}

const useCopyJobPost = () => {
    const { addToast } = useToast();
    const mutationFn = async (variables: ICopyJobPostPayload): Promise<IJobPostList> => {
        const { payload } = variables;

        const response = await api.post(`/job-posts/copy/${payload.id}`);
        return response.data;
    }

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessing(true);
            variables.setErrorMessage(null);
        },
        onSuccess: (data, variables) => {
            variables.successCallback(data);
            variables.setIsProcessing(false);
            variables.setErrorMessage(null);
        },
        onError: (error, variables) => {
            addToast({
                type: 'error',
                title: 'Failed to copy job post',
            });
            variables.setErrorMessage(error.message);
            variables.setIsProcessing(false);
        },
    });
}

export default useCopyJobPost;
